export const LoginService = async ({email , password ,BeURl , state}) => {
    try{
        const response = await fetch(`${BeURl}/signin`,{
            method: "POST",
            headers: {  
                "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({ email, password, state }),
        });
        return response.json();
    }
    catch(err){
        console.log("LOGIN SERVICE ERROR", err);
    }
}


